<template>
  <button v-if="disabled == null || !disabled" type="button" class="flex align-items-center" @click="changeOrder">{{ title }} <div class="flex flex-column ml-1 order" ><font-awesome-icon v-if="(orderBy === column && order === 'ASC') || order === ''" icon="fa-solid fa-caret-up" /> <font-awesome-icon v-if="(orderBy === column && order === 'DESC') || order === ''" icon="fa-solid fa-caret-down" /></div></button>
  <span v-else> {{ title }}</span>
</template>

<script>
export default {
  props: ['title', 'column', 'orderBy', 'order', 'disabled', 'defaultOrder'],
  methods: {
    changeOrder() {
      if (this.orderBy === this.column) {
        if (this.defaultOrder?.toLowerCase() === 'desc') {
          if (this.order === '') {
            this.$emit('update:order', 'DESC')
          } else if (this.order === 'DESC') {
            this.$emit('update:order', 'ASC')
          } else {
            this.$emit('update:order', '')
          }
        } else {
          if (this.order === '') {
            this.$emit('update:order', 'ASC')
          } else if (this.order === 'ASC') {
            this.$emit('update:order', 'DESC')
          } else {
            this.$emit('update:order', '')
          }
        }
      } else {
        this.$emit('update:orderBy', this.column)
        this.$emit('update:order', this.defaultOrder?.toLowerCase() === 'desc' ? 'DESC' : 'ASC')
      }
    }
  }
}
</script>

<style scoped>
button {
  div {
    margin-left: 4px;
    margin-right: -12px;
    width: 8px
  }

  .svg-inline--fa {
    height: 10px;
  }
}
</style>
